const STORED_REDIRECT_KEY = 'intendedRedirect';

const decodeRedirect = (value) => {
  if (!value) return null;

  let decoded = value;
  try {
    decoded = decodeURIComponent(value);
  } catch {
    return null;
  }

  if (!decoded.startsWith('/') || decoded.startsWith('//')) return null;

  try {
    const url = new URL(decoded, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname === '/login') return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};

const getStorage = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const getSafeLoginRedirect = (search = '', storage = getStorage()) => {
  const params = new URLSearchParams(search);
  const queryValue = params.get('redirect') || params.get('intended');
  if (queryValue !== null) return decodeRedirect(queryValue);
  return decodeRedirect(storage?.getItem(STORED_REDIRECT_KEY));
};

export const persistLoginRedirect = (search = '', storage = getStorage()) => {
  const params = new URLSearchParams(search);
  const redirect = decodeRedirect(params.get('redirect') || params.get('intended'));
  if (redirect && storage) storage.setItem(STORED_REDIRECT_KEY, redirect);
  return redirect;
};

export const clearStoredLoginRedirect = (storage = getStorage()) => {
  storage?.removeItem(STORED_REDIRECT_KEY);
};
